
  import { Component, Vue } from 'vue-property-decorator'
  import { VuetifyItemInterface } from '@/views/interfaces/vuetify/item.interface';

  @Component
  export default class PagesCoreAppBar extends Vue {
    private items: VuetifyItemInterface[] = [
      {
        icon: 'mdi-fingerprint',
        text: 'Login',
        to: '/login',
      },
    ]

    private titles: { [key: string]: string } = {
      '/pages/lock': 'Lock Page',
      '/pages/login': 'Login Page',
      '/pages/pricing': 'Pricing Page',
      '/pages/register': 'Register Page',
    }

    get title(): string {
      return this.titles[this.$route.path]
    }
  }
